// @ts-expect-error module not typed
import PrimaryMessageContentSection from '../../primary-message/components/PrimaryMessageContentSection';
// @ts-expect-error module not typed
import ContentText from '../../primary-message/ContentText';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledPrimaryMessageContentSection = styled(PrimaryMessageContentSection).withConfig({
  displayName: "WorkflowGeneratedUserMessageContent__StyledPrimaryMessageContentSection",
  componentId: "z3i1zw-0"
})(["padding-left:8px;padding-right:8px;padding-bottom:8px;"]);
const WorkflowGeneratedUserMessageContent = ({
  messageText,
  isPlainText = false
}) => {
  return /*#__PURE__*/_jsx(StyledPrimaryMessageContentSection, {
    canExpand: true,
    isLastMessage: true,
    children: /*#__PURE__*/_jsx(ContentText, {
      contentText: messageText,
      isPlainText: isPlainText
    })
  });
};
WorkflowGeneratedUserMessageContent.displayName = 'WorkflowGeneratedUserMessageContent';
export default WorkflowGeneratedUserMessageContent;